module.exports = __webpack_public_path__ + "img/googleLogo.bfd8aed4.svg";